import React from "react";

const NoticeMsg = ({ notice, msg }) => {
  
  let bg;

  switch (notice) {
    case "error":
      bg = "bg-red-200 ring-red-600 text-red-600";
      break;

    case "success":
      bg = "bg-green-200 ring-green-600 text-green-600";
      break;

    default:
      break;
  }

  return (
    <div
      className={`w-full ${bg} h-auto rounded-lg flex items-center p-3 ring-2`}
    >
      <span>{msg}</span>
    </div>
  );
};

export default NoticeMsg;
